export const GET_CATEGORIES_PENDING = 'GET_CATEGORIES_PENDING'
export const GET_CATEGORIES_SUCCESSFUL = 'GET_CATEGORIES_SUCCESSFUL'
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR'
